export default {
  VerifyModal: {
    title: "Verifique sua conta",
    send: "Enviar para verificação",
    step1: {
      reason:
        "O serviço é criado exclusivamente para profissionais médicos, portanto, o acesso a algumas funções é limitado apenas a usuários verificados. Isso permite:",
      reasons: {
        1: "Excluir o acesso de pacientes e pessoas não autorizadas",
        2: "Garantir uma comunidade profissional para troca de conhecimentos e experiências",
        3: "Cumprir a ética médica e os padrões de manipulação de dados",
      },
      end: "Valorizamos sua segurança e privacidade. Todas as informações são usadas apenas para verificar seu status e serão excluídas após a conclusão do processo.",
      status: "Status",
      statuses: {
        doctor: "Médico",
        student: "Estudante",
        ordinator: "Residente",
      },
    },
    step2: {
      agenda:
        "Todos os dados fornecidos estão protegidos e são usados exclusivamente para verificar seu status.",
      chooseVerifyWay: "Escolha o método de verificação",
      ways: {
        1: "Diploma, certificado ou identificação profissional",
        2: "Link para sua página verificada em um agregador médico (ProDoctors, DocDoc, etc.)",
        3: "Link para sua página no site da clínica",
        4: "Envie seu diploma de formação médica",
        5: "Envie seu cartão de estudante de universidade médica",
      },
      selectFile: "Selecionar arquivo",
      sendToCheck: "Enviar para verificação",
      pasteLink: "Cole o link",
      notAllowedFile: "Apenas PDF e imagens são permitidos.",
      noMoreFiles: "Número máximo de arquivos - ",
    },
    step3: {
      title: "Documento enviado para verificação",
      text1_1:
        "Verificaremos suas informações, após isso você receberá uma notificação no e-mail ",
      text1_2: "",
      text2: "A verificação leva um dia útil.",
    },
  },
};
